import * as assets from './assets'
import * as auth from './auth'
import * as chart from './chart'
import * as orders from './orders'
import * as positions from './positions'
import * as user from './user'

export default {
	assets,
	auth,
	chart,
	orders,
	positions,
	user
}
